<template>
  <div class="main-page">
    <Header></Header>
    <Banner></Banner>
    <div class="m-pc-page page-bottom">
      <List></List>
    </div>
  </div>
</template>
<script>
//import Vue from "vue";
import Header from "../components/Header";
// import Column from "../components/Column.vue";
import Banner from "../components/Banner.vue";
import List from "../components/List.vue";
//import { $subscriber } from "fire-wind-water";
// import $ from "jquery";

export default {
  name: "Article",
  data() {
    return {
      //      page:{
      //        backgroundColor:{
      //          value:''
      //        }
      //      }
    };
  },
  components: {
    Header,
    // Column,
    Banner,
    List
  },
  created() {
    //    $subscriber.subscribe("config-loaded", res=>{
    //      this.page = res.page;
    //      // $('body').css('background-color',this.page.backgroundColor.value)
    //      window.$sk.loading.hide();
    //    });
  }
};
</script>
